import { EllipsisVerticalIcon } from "@heroicons/react/24/outline";
import { DragSourceMonitor, useDrag } from "react-dnd";
import { Rule } from "../models/rule";

export type AvailableRuleProps = {
  rule: Rule;
  addRule: (rule: Rule) => void;
  index: number;
};

export interface DropResult {
  allowedDropEffect: string;
  dropEffect: string;
  name: string;
}

const AvailableRule = (props: AvailableRuleProps) => {
  const rule = props.rule;
  const addRule = props.addRule;

  const [collected, drag] = useDrag(
    () => ({
      type: "rule",
      item: { rule },
      end(item, monitor) {
        const dropResult = monitor.getDropResult() as DropResult;
        if (item && dropResult) {
          addRule(item.rule);
        }
      },
      collect: (monitor: DragSourceMonitor) => {
        return {
          opacity: monitor.isDragging() ? 0.4 : 0,
          isDragging: monitor.isDragging(),
          offset: monitor.getDifferenceFromInitialOffset() || {
            x: 0,
            y: 0,
          },
        };
      },
    }),
    [rule]
  );

  return (
    <>
      <div ref={drag}>
        <div
          className={`rounded-md border shadow border-gray-100 p-2 bg-white cursor-move ${
            collected.opacity > 0 ? "opacity-40" : ""
          } text-gray-400 hover:text-red-500 hover:border-l-8 hover:pl-[1px] hover:border-l-red-500`}
        >
          <div className="text-sm p-4 bg-gray-100 rounded-md flex items-center justify-start gap-2">
            <EllipsisVerticalIcon className={`h-4 w-4 -ml-2`} />
            <EllipsisVerticalIcon className={`h-4 w-4 -ml-5`} />
            <div className="w-3/4 md:w-auto text-black">{rule.name}</div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AvailableRule;
